import { AssetViewer } from '../AssetViewer';
import { ASSET_TYPE } from '../../constants/Constants';
import { PresentationHelper } from '../../helpers/PresentationHelper';
import { ViewerEventType, ViewerPublicFocusChangeEvent, ViewerPublicRenderedPreviewFocusEvent, ViewerPublicRenderedViewFocusEvent } from '../../types/ViewerEvents.type';
import { AssetViewerViewMapper } from '../../helpers/AssetViewerViewMapper';
export class AssetViewerPresentationRenderer {
    constructor(assetViewerView) {
        this.assetViewerView = assetViewerView;
        this.isActive = true;
        this.isLoading = false;
        this.assetViewer = null;
        this.createAssetViewer();
        this.onAssetViewerUpdate = this.onAssetViewerUpdate.bind(this);
        this.onAssetViewerFocusChange = this.onAssetViewerFocusChange.bind(this);
        this.onAssetViewerRenderedViewFocus = this.onAssetViewerRenderedViewFocus.bind(this);
        this.onAssetViewerRenderedPreviewFocus = this.onAssetViewerRenderedPreviewFocus.bind(this);
        this.onAssetViewerViewportChange = this.onAssetViewerViewportChange.bind(this);
        this.onAssetViewerViewRendered = this.onAssetViewerViewRendered.bind(this);
        this.onAssetViewerSelectView = this.onAssetViewerSelectView.bind(this);
        this.onAssetViewerDeselectView = this.onAssetViewerDeselectView.bind(this);
        this.onAssetViewerUrlAssetClicked = this.onAssetViewerUrlAssetClicked.bind(this);
        this.onOpenInOfficeOnline = this.onOpenInOfficeOnline.bind(this);
        this.addEventListeners();
    }
    get url() {
        return '';
    }
    get dimensions() {
        return { width: 400, height: 300 };
    }
    get hasMetaData() {
        return !!this.dimensions;
    }
    load() { }
    render(container) {
        if (this.assetViewer) {
            this.initAssetViewer(container);
        }
        return Promise.resolve();
    }
    destroy() { }
    destroyFinal() {
        if (this.assetViewer) {
            this.removeEventListeners();
            this.assetViewer.destroy();
            this.assetViewer = null;
        }
    }
    createAssetViewer() {
        const assetViewerItems = [this.assetViewerView.assetViewerItem];
        const isDocument = this.assetViewerView.assetViewerItem.type === ASSET_TYPE.DOCUMENT;
        const isPortrait = isDocument ? PresentationHelper.isDocumentPortrait(this.assetViewerView.assetViewerItem) : false;
        // TODO make this more configurable from the Config
        let config;
        if (isDocument) {
            // SPW-6137 Added for learncore
            if (isPortrait || this.assetViewerView.config.DOCUMENT_FORCE_PORTRAIT_VIEWER) {
                if (this.assetViewerView.config.PORTRAIT_DOCUMENT_ASSET_VIEWER_CONFIG) {
                    config = this.assetViewerView.config.PORTRAIT_DOCUMENT_ASSET_VIEWER_CONFIG;
                }
                else if (this.assetViewerView.config.DOCUMENT_ASSET_VIEWER_CONFIG) {
                    config = this.assetViewerView.config.DOCUMENT_ASSET_VIEWER_CONFIG;
                }
                else {
                    config = this.assetViewerView.config;
                }
            }
            else {
                if (this.assetViewerView.config.DOCUMENT_ASSET_VIEWER_CONFIG) {
                    config = this.assetViewerView.config.DOCUMENT_ASSET_VIEWER_CONFIG;
                }
                else {
                    config = this.assetViewerView.config;
                }
            }
        }
        else {
            config = this.assetViewerView.config;
        }
        config.container = this.assetViewerView.contentElement;
        config.IS_SLAVE_ASSET_VIEWER = true;
        config.rootAssetViewer = this.assetViewerView.config.rootAssetViewer;
        this.assetViewerView.contentElement.classList.add('av-embedded-asset-viewer');
        this.assetViewer = new AssetViewer(assetViewerItems, config);
    }
    initAssetViewer(container) {
        // TODO fix
        // TODO make sure the thumbnailViewer isn't preloaded, this will render other previews in the thumbnailContainer.
        // // thumbnailViewer layout needs to be rendered before the update cycle of the main viewer starts, because the thumbnails viewer doesn't trigger an update event on init, because it wouldn't have load priority.
        // this.assetViewer.initThumbnailViewer();
        this.assetViewer.init(0, this.pageToInit, container);
    }
    addEventListeners() {
        this.assetViewer.eventBus.on(ViewerEventType.Update, this.onAssetViewerUpdate);
        this.assetViewer.eventBus.on(ViewerEventType.FocusChange, this.onAssetViewerFocusChange);
        this.assetViewer.eventBus.on(ViewerEventType.RenderedViewFocus, this.onAssetViewerRenderedViewFocus);
        this.assetViewer.eventBus.on(ViewerEventType.RenderedPreviewFocus, this.onAssetViewerRenderedPreviewFocus);
        this.assetViewer.eventBus.on(ViewerEventType.ViewportChange, this.onAssetViewerViewportChange);
        this.assetViewer.eventBus.on(ViewerEventType.SelectView, this.onAssetViewerSelectView);
        this.assetViewer.eventBus.on(ViewerEventType.DeselectView, this.onAssetViewerDeselectView);
        this.assetViewer.eventBus.on(ViewerEventType.UrlAssetClicked, this.onAssetViewerUrlAssetClicked);
        this.assetViewer.eventBus.on(ViewerEventType.OpenInOfficeOnline, this.onOpenInOfficeOnline);
    }
    removeEventListeners() {
        this.assetViewer.eventBus.off(ViewerEventType.Update, this.onAssetViewerUpdate);
        this.assetViewer.eventBus.off(ViewerEventType.FocusChange, this.onAssetViewerFocusChange);
        this.assetViewer.eventBus.off(ViewerEventType.RenderedViewFocus, this.onAssetViewerRenderedViewFocus);
        this.assetViewer.eventBus.off(ViewerEventType.RenderedPreviewFocus, this.onAssetViewerViewportChange);
        this.assetViewer.eventBus.off(ViewerEventType.ViewportChange, this.onAssetViewerViewportChange);
        this.assetViewer.eventBus.off(ViewerEventType.SelectView, this.onAssetViewerSelectView);
        this.assetViewer.eventBus.off(ViewerEventType.DeselectView, this.onAssetViewerDeselectView);
        this.assetViewer.eventBus.off(ViewerEventType.UrlAssetClicked, this.onAssetViewerUrlAssetClicked);
        this.assetViewer.eventBus.off(ViewerEventType.OpenInOfficeOnline, this.onOpenInOfficeOnline);
    }
    isViewFocussed(assetViewerView) {
        return assetViewerView === assetViewerView.viewerLayout.viewState.focus.view;
    }
    onAssetViewerUpdate(event) {
        this.assetViewerView.eventBus.dispatch(event);
    }
    onAssetViewerFocusChange(event) {
        if (this.isViewFocussed(this.assetViewerView)) {
            this.assetViewerView.eventBus.dispatch(new ViewerPublicFocusChangeEvent({ assetViewerView: event.payload.assetViewerView }));
        }
    }
    onAssetViewerRenderedViewFocus(event) {
        if (this.isViewFocussed(this.assetViewerView)) {
            this.assetViewerView.eventBus.dispatch(new ViewerPublicRenderedViewFocusEvent({ assetViewerView: event.payload.assetViewerView }));
        }
    }
    onAssetViewerRenderedPreviewFocus(event) {
        if (this.isViewFocussed(this.assetViewerView)) {
            this.assetViewerView.eventBus.dispatch(new ViewerPublicRenderedPreviewFocusEvent({ assetViewerView: event.payload.assetViewerView }));
        }
    }
    onAssetViewerViewportChange(event) {
        this.assetViewerView.eventBus.dispatch(event);
    }
    onAssetViewerViewRendered(event) {
        this.assetViewerView.eventBus.dispatch(event);
    }
    onAssetViewerSelectView(event) {
        this.assetViewerView.eventBus.dispatch(event);
    }
    onAssetViewerDeselectView(event) {
        this.assetViewerView.eventBus.dispatch(event);
    }
    onAssetViewerUrlAssetClicked(event) {
        this.assetViewerView.eventBus.dispatch(event);
    }
    onOpenInOfficeOnline(event) {
        this.assetViewerView.eventBus.dispatch(event);
    }
    getAssetViewerViews() {
        const assetViewerViews = this.assetViewer.viewer.views.map(assetViewerView => AssetViewerViewMapper.mapToPublicAssetViewerView(assetViewerView));
        return assetViewerViews;
    }
}
//# sourceMappingURL=AssetViewerPresentationRenderer.js.map